var ComputeType = /* @__PURE__ */ ((ComputeType2) => {
  ComputeType2["CosmosVC"] = "CosmosVC";
  ComputeType2["Synapse"] = "Synapse";
  ComputeType2["BlueshiftADLA"] = "BlueshiftADLA";
  ComputeType2["CosmosADLA"] = "CosmosADLA";
  return ComputeType2;
})(ComputeType || {});
var PlaceHolder = /* @__PURE__ */ ((PlaceHolder2) => {
  PlaceHolder2["ComputeName"] = "Lowercase alphanumeric, hyphen and underscore allowed.";
  PlaceHolder2["ComputeNameAutoGenerated"] = "Name will be generated with Cluster and VC.";
  PlaceHolder2["ComputeType"] = "Select compute resource type.";
  PlaceHolder2["Cluster"] = "Cluster name. (e.g. cosmos09)";
  PlaceHolder2["VCName"] = "VC name. (e.g. searchdmprod. Only lowercase letters are accepted.)";
  PlaceHolder2["VCMaxConcurrentJobs"] = "This field allows users to set the maximum number of concurrent jobs allowed. This field should be set in consultatation with VC admins. Default value of 100.";
  PlaceHolder2["Owners"] = "Enter owner alias";
  PlaceHolder2["SubClusterName"] = "Alphanumeric, hyphen and underscore allowed.";
  PlaceHolder2["KeyVaultURL"] = "Enter KeyVault URL";
  PlaceHolder2["ClusterType"] = "";
  PlaceHolder2["ClusterMaxConcurrentJobs"] = "";
  PlaceHolder2["ClusterScale"] = "";
  PlaceHolder2["ClusterRuntimeVersion"] = "Select Cluster runtime version";
  PlaceHolder2["InstancePoolId"] = "Enter Instance Pool Id.";
  PlaceHolder2["NodeType"] = "Enter Azure VM sku name";
  PlaceHolder2["MinimumWorkersInCluster"] = "Minimum number of workers in cluster. Default 1.";
  PlaceHolder2["MaximumWorkersInCluster"] = "Maximum number of workers in cluster. Default 1.";
  PlaceHolder2["NumberOfWorkersInCluster"] = "Enter number of workers in cluster. Default 1.";
  PlaceHolder2["DevelopmentUrl"] = "Enter Synapse URL.";
  PlaceHolder2["StorageAccount"] = "Enter storage account name.";
  PlaceHolder2["StorageContainer"] = "Enter storage account container name.";
  PlaceHolder2["PoolName"] = "Enter spark pool name.";
  PlaceHolder2["NodeSize"] = "Select executor size.";
  PlaceHolder2["MinimumWorkersPerTask"] = "Minimum number of workers per task. Default 1.";
  PlaceHolder2["MaximumWorkersPerTask"] = "Maximum number of workers per task. Default 1.";
  PlaceHolder2["NumberOfWorkersPerTask"] = "Enter number of workers per task. Default 1.";
  PlaceHolder2["ADLAAcount"] = "the acount name of ADLA(e.g. exptestblueshift)";
  PlaceHolder2["DefaultStorageAccount"] = "Provide the default storage account of ADLA";
  PlaceHolder2["ScorecardOutputStorageAccount"] = "Please select your output storage account";
  PlaceHolder2["ServicePrincipalName"] = "Please select your principal";
  PlaceHolder2["BlueshiftMaxConcurrentJobs"] = "This field allows users to set the maximum number of concurrent jobs allowed. This field should be set in consultatation with admins. Default value of 100.";
  PlaceHolder2["CosmosADLAMaxConcurrentJobs"] = "This field allows users to set the maximum number of concurrent jobs allowed. This field should be set in consultatation with admins. Default value of 100.";
  return PlaceHolder2;
})(PlaceHolder || {});
var AriaLabel = /* @__PURE__ */ ((AriaLabel2) => {
  AriaLabel2["ComputeName"] = "Name";
  AriaLabel2["ComputeType"] = "Compute type";
  AriaLabel2["Cluster"] = "Cluster";
  AriaLabel2["VCName"] = "Virtual cluster name";
  AriaLabel2["VCMaxConcurrentJobs"] = "Virtual cluster max concurrent jobs";
  AriaLabel2["Owners"] = "Owners";
  AriaLabel2["SubClusterName"] = "Name";
  AriaLabel2["KeyVaultURL"] = "Key Vault URL";
  AriaLabel2["ClusterType"] = "Cluster type";
  AriaLabel2["ClusterMaxConcurrentJobs"] = "Cluster max concurrent jobs";
  AriaLabel2["ClusterScale"] = "Cluster scale";
  AriaLabel2["ClusterRuntimeVersion"] = "Cluster runtime version";
  AriaLabel2["InstancePoolId"] = "Instance pool Id";
  AriaLabel2["NodeType"] = "Node type";
  AriaLabel2["MinimumWorkersInCluster"] = "Minimum workers in cluster";
  AriaLabel2["MaximumWorkersInCluster"] = "Maximum workers in cluster";
  AriaLabel2["NumberOfWorkersInCluster"] = "Number of workers in cluster";
  AriaLabel2["DevelopmentUrl"] = "Synapse endpoint";
  AriaLabel2["StorageAccount"] = "Default storage account name";
  AriaLabel2["StorageContainer"] = "Default storage account container";
  AriaLabel2["PoolName"] = "Spark pool name";
  AriaLabel2["NodeSize"] = "Executor size";
  AriaLabel2["MinimumWorkersPerTask"] = "Minimum workers per task";
  AriaLabel2["MaximumWorkersPerTask"] = "Maximum workers per task";
  AriaLabel2["NumberOfWorkersPerTask"] = "Number of workers per task";
  AriaLabel2["ADLAAcount"] = "ADLA acount";
  AriaLabel2["DefaultStorageAccount"] = "Default Storage Account";
  AriaLabel2["ScorecardOutputStorageAccount"] = "Scorecard Output Storage Account";
  AriaLabel2["ServicePrincipalName"] = "Service principal name";
  AriaLabel2["BlueshiftMaxConcurrentJobs"] = "Blueshift ADLA max concurrent jobs";
  AriaLabel2["CosmosADLAMaxConcurrentJobs"] = "Cosmos ADLA max concurrent jobs";
  return AriaLabel2;
})(AriaLabel || {});
export {
  AriaLabel,
  ComputeType,
  PlaceHolder
};
//# sourceMappingURL=ComputeAbstract.js.map
